import React from "react";
import Select from "react-select";
import { Controller } from "react-hook-form";
import ValidationMsgComponent from "../ValidationMsgComponent";
import { Col, Label, Row } from "reactstrap";

interface ControlledSelectForFilteringProps {
  label: string;
  inputName: string;
  placeholder?: string;
  invalid?: boolean;
  control: any;
  rules?: object;
  errors?: object;
  isRequired?: boolean;
  hasSideLabel?: boolean;
  sideLabel?: string;
  isDisabled?: boolean;
  defaultValue?: string;
  className?: string;
  optionsList: any;
  isLoading?: boolean;
  isSearchable?: boolean;
  defaultSelectedValue?: any;
  isMulti?: boolean;
  isClear?: boolean;
  value?: any;
}

const ControlledSelectForFiltering: React.FC<
  ControlledSelectForFilteringProps
> = ({
  label,
  inputName,
  optionsList,
  invalid,
  control,
  isLoading,
  isSearchable,
  rules,
  errors,
  defaultSelectedValue,
  isRequired,
  isMulti,
  hasSideLabel,
  sideLabel,
  isDisabled,
  placeholder,
  isClear,
}) => {
  return (
    <div className="my-1">

        <Label
          className={`${label === "" ? "pt-1" : ""} form-label`}
          htmlFor={inputName}
        >
          {isRequired ? `${label}` : label}
        </Label>
      <Row>
        <Col>
          <Controller
            name={inputName}
            control={control}
            rules={rules}
            render={({ field }) => (
              <Select
                id={inputName}
                classNamePrefix="select"
                options={optionsList}
                isClearable={isClear}
                isLoading={isLoading}
                isSearchable={isSearchable}
                isMulti={isMulti}
                isDisabled={isDisabled}
                defaultValue={defaultSelectedValue}
                placeholder={placeholder}
                {...field}
                required={isRequired}
              />
            )}
          />
          {hasSideLabel && <span className="ps-1 me-1">{sideLabel}</span>}
          {invalid && (
            <ValidationMsgComponent
              inputName={inputName}
              invalid={invalid}
              errors={errors}
              rules={rules}
            />
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ControlledSelectForFiltering;
